module.exports = __webpack_public_path__ + "static/media/Placaj ceramic Klinker Bayonne.05c43bc9.jpg";